import React, { useContext, useEffect, useRef, useState } from "react";
import { useChat } from '../../../services/CuratorChatUtils';
import ChatMessageLine from "./InputLine";
import { RiCheckDoubleLine } from "react-icons/ri";
import { observer } from "mobx-react-lite";
import { Context } from "../../..";
import dayjs from "dayjs";

const ChatRoom = observer(({ room, getLastM }) => {
    const { user } = useContext(Context);
    const chatRef = useRef(null);
    const [messages, setMessages] = useState([]);

    const { allMessages, sendJsonMessage, lastJsonMessage } = useChat(room.id, {
        onOpen: () => console.log(`Подключено к комнате: ${room.id}`),
        onError: (err) => console.error("Ошибка подключения к комнате:", err),
    });

    // Устанавливаем сообщения, когда allMessages обновляется
    useEffect(() => {
        if (allMessages.length > 0) {
            setMessages(allMessages.reverse());
        }
    }, [allMessages]);

    // Обработка последнего сообщения
    useEffect(() => {
        if (lastJsonMessage) {
            getLastM(lastJsonMessage);
            setMessages((prevMessages) => [...prevMessages, lastJsonMessage]);
        }
    }, [lastJsonMessage, getLastM]);

    // Прокрутка вниз, когда появляются новые сообщения
    useEffect(() => {
        if (chatRef.current) {
            setTimeout(() => {
                chatRef.current.scrollTop = chatRef.current.scrollHeight;
            }, 0);
        }
    }, [messages]);

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return "";
        return dayjs(timestamp).format("HH:mm");
    };

    const addMessage = (message) => {
        setMessages((prevMessages) => [...prevMessages, message]);
    };

    return (
        <div className="h-screen flex flex-col">
            {/* Сообщения */}
            <div
                ref={chatRef}
                className="flex-1 overflow-y-auto bg-[#EBEBFA] p-4 pb-[150px] "
            >
                {messages.map((msg) => (
                    msg && msg.message && (
                        <div
                            key={msg.id}
                            className={`flex ${
                                msg.sender_id === user.user.id ? "justify-end" : "justify-start"
                            } mb-4`}
                        >
                            <div
                                className={`max-w-[70%] px-4 py-2 rounded-lg shadow-sm ${
                                    msg.sender_id === user.user.id
                                        ? "bg-[#7A4CA0] text-white"
                                        : "bg-white text-gray-900"
                                }`}
                            >
                                <p>{msg.message}</p>
                                <div className="flex items-center justify-end mt-1">
                            <span className="text-xs opacity-70">
                                {formatTimestamp(msg.timestamp)}
                            </span>
                                    {msg.sender_id === user.user.id && (
                                        <RiCheckDoubleLine className="ml-1 text-sm"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                ))}
            </div>

            {/* Ввод сообщения */}
            <ChatMessageLine roomId={room.id} sendMessage={addMessage} sendJsonMessage={sendJsonMessage}/>
        </div>
    );
});

export default ChatRoom;